export default {"src":"/_next/static/media/photographic_tours.3593d843.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};